import {Timeline, VisuallyHidden} from '@primer/react'
import {SkeletonBox, SkeletonText} from '@primer/react/experimental'
import styles from './TimelinePanel.module.css'

export function TimelinePanelSkeleton({count = 7}: {count?: number}) {
  return (
    <div role="status" aria-live="polite" aria-busy>
      <VisuallyHidden>Loading timeline</VisuallyHidden>
      <Timeline clipSidebar="both" aria-hidden>
        <TimelinePanelSkeletonRows count={count} />
      </Timeline>
    </div>
  )
}

export function TimelinePanelSkeletonRows({count = 7}: {count?: number}) {
  return Array.from({length: count}, (_, i) => <TimelineEventSkeletonRow key={i} />)
}

function TimelineEventSkeletonRow() {
  return (
    <Timeline.Item condensed>
      <Timeline.Badge>
        <SkeletonBox className={styles.skeletonBadge} />
      </Timeline.Badge>
      <Timeline.Body>
        <SkeletonText size="bodySmall" className={styles.skeletonActorText} />
      </Timeline.Body>
    </Timeline.Item>
  )
}
